export const ActionType = {

    USER_LOGIN: 'USER_LOGIN',
    USER_LOGOUT: 'USER_LOGOUT',
    SET_LANGUAGE: 'SET_LANGUAGE',

    //Login
    LOGIN_USER_BEGIN: 'LOGIN_USER_BEGIN',
    LOGIN_USER_SUCCESS: 'LOGIN_USER_SUCCESS',
    LOGIN_USER_FAILURE: 'LOGIN_USER_FAILURE',
    QUIT_SESSIONS_BEGIN: 'QUIT_SESSIONS_BEGIN',
    QUIT_SESSIONS_SUCCESS: 'QUIT_SESSIONS_SUCCESS',
    QUIT_SESSIONS_ERROR: 'QUIT_SESSIONS_ERROR',

    GET_SESSION_HISTORY_BEGIN: 'GET_SESSION_HISTORY_BEGIN',
    GET_SESSION_HISTORY_SUCCESS: 'GET_SESSION_HISTORY_SUCCESS',
    GET_SESSION_HISTORY_ERROR: 'GET_SESSION_HISTORY_ERROR',

    TOGGLE_SIDEBAR_MENU: 'TOGGLE_SIDEBAR_MENU',
    TOGGLE_MOBILE_NAV_MENU: 'TOGGLE_MOBILE_NAV_MENU',

    //Registration
    REGISTER_USER_BEGIN: 'REGISTER_USER_BEGIN',
    REGISTER_USER_SUCCESS: 'REGISTER_USER_SUCCESS',
    REGISTER_USER_ERROR: 'REGISTER_USER_ERROR',
    GET_LOCATION_SUCCESS: 'GET_LOCATION_SUCCESS',

    //Check registration data
    CHECK_REGISTRATION_DATA_BEGIN: 'CHECK_REGISTRATION_DATA_BEGIN',
    CHECK_REGISTRATION_DATA_SUCCESS: 'CHECK_REGISTRATION_DATA_SUCCESS',
    CHECK_REGISTRATION_DATA_ERROR: 'CHECK_REGISTRATION_DATA_ERROR',
    CHECK_REGISTRATION_ERROR_RESET: 'CHECK_REGISTRATION_ERROR_RESET',

    //Edit Profile
    EDIT_PROFILE_BEGIN: 'EDIT_PROFILE_BEGIN',
    EDIT_PROFILE_ERROR: 'EDIT_PROFILE_ERROR',
    EDIT_PROFILE_SUCCESS: 'EDIT_PROFILE_SUCCESS',
    CHANGE_PLAYER_DATA: 'CHANGE_PLAYER_DATA',

    RESET_SUCCESS_MESSAGE: 'RESET_SUCCESS_MESSAGE',

    GET_DEPOSIT_BEGIN: 'GET_DEPOSIT_BEGIN',
    GET_DEPOSIT_ERROR: 'GET_DEPOSIT_ERROR',
    GET_DEPOSIT_SUCCESS: 'GET_DEPOSIT_SUCCESS',
    GET_WITHDRAWALS_BEGIN: 'GET_WITHDRAWALS_BEGIN',
    SET_LOADING_STATE: 'SET_LOADING_STATE',
    GET_DITHRAWALS_ERROR: 'GET_DITHRAWALS_ERROR',
    GET_DITHRAWALS_SUCCESS: 'GET_DITHRAWALS_SUCCESS',
    GET_BETS_HISTORY_BEGIN: 'GET_BETS_HISTORY_BEGIN',
    GET_BETS_HISTORY_ERROR: 'GET_BETS_HISTORY_ERROR',
    GET_BETS_HISTORY_SUCCESS: 'GET_BETS_HISTORY_SUCCESS',
    GET_REFERRER_REPORT_BEGIN: 'GET_REFERRER_REPORT_BEGIN',
    GET_REFERRER_REPORT_ERROR: 'GET_REFERRER_REPORT_ERROR',
    GET_REFERRER_REPORT_SUCCESS: 'GET_REFERRER_REPORT_SUCCESS',
    GET_TRANSACTIONS_HISTORY_BY_TYPE_BEGIN: 'GET_TRANSACTIONS_HISTORY_BY_TYPE_BEGIN',
    GET_TRANSACTIONS_HISTORY_BY_TYPE_ERROR: 'GET_TRANSACTIONS_HISTORY_BY_TYPE_ERROR',
    GET_TRANSACTIONS_HISTORY_BY_TYPE_SUCCESS: 'GET_TRANSACTIONS_HISTORY_BY_TYPE_SUCCESS',
    CANCEL_WITHDRAWAL_BEGIN: 'CANCEL_WITHDRAWAL_BEGIN',
    CANCEL_WITHDRAWAL_BEGIN_NO_RESET: 'CANCEL_WITHDRAWAL_BEGIN_NO_RESET',
    CANCEL_WITHDRAWAL_ERROR: 'CANCEL_WITHDRAWAL_ERROR',
    CANCEL_WITHDRAWAL_SUCCESS: 'CANCEL_WITHDRAWAL_SUCCESS',

    GET_TOURNAMENTS_HISTORY_BEGIN: 'GET_TOURNAMENTS_HISTORY_BEGIN',
    GET_TOURNAMENTS_HISTORY_ERROR: 'GET_TOURNAMENTS_HISTORY_ERROR',
    GET_TOURNAMENTS_HISTORY_SUCCESS: 'GET_TOURNAMENTS_HISTORY_SUCCESS',

    RESET_CALLBACK_STATUS: 'RESET_CALLBACK_STATUS',

    FORGOT_PASSWORD_RECOVERY_BEGIN: 'FORGOT_PASSWORD_RECOVERY_BEGIN',
    FORGOT_PASSWORD_RECOVERY_SUCCESS: 'FORGOT_PASSWORD_RECOVERY_SUCCESS',
    FORGOT_PASSWORD_RECOVERY_ERROR: 'FORGOT_PASSWORD_RECOVERY_ERROR',

    RECOVER_PASSWORD_BEGIN: 'RECOVER_PASSWORD_BEGIN',
    RECOVER_PASSWORD_SUCCESS: 'RECOVER_PASSWORD_SUCCESS',
    RECOVER_PASSWORD_ERROR: 'RECOVER_PASSWORD_ERROR',

    RECOVER_USER_NAME_BEGIN: 'RECOVER_USER_NAME_BEGIN',
    RECOVER_USER_NAME_SUCCESS: 'RECOVER_USER_NAME_SUCCESS',
    RECOVER_USER_NAME_ERROR: 'RECOVER_USER_NAME_ERROR',

    CHANGE_PASSWORD_BEGIN: 'CHANGE_PASSWORD_BEGIN',
    CHANGE_PASSWORD_ERROR: 'CHANGE_PASSWORD_ERROR',
    CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',

    GET_LOG_HISTORY: 'GET_LOG_HISTORY',

    /* CASINO GAMES */
    GET_GAME_CATEGORIES_BEGIN: 'GET_GAME_CATEGORIES_BEGIN',
    GET_GAME_CATEGORIES_SUCCESS: 'GET_GAME_CATEGORIES_SUCCESS',
    GET_GAME_CATEGORIES_ERROR: 'GET_GAME_CATEGORIES_ERROR',

    GET_GAMES_BEGIN: 'GET_GAMES_BEGIN',
    GET_GAMES_AND_KEEP_OLD_BEGIN: 'GET_GAMES_AND_KEEP_OLD_BEGIN',
    GET_GAMES_SUCCESS: 'GET_GAMES_SUCCESS',
    GET_GAMES_ERROR: 'GET_GAMES_ERROR',
    GET_GAMES_AND_KEEP_OLD_SUCCESS: 'GET_GAMES_AND_KEEP_OLD_SUCCESS',

    GET_RECENT_GAMES_BEGIN: 'GET_RECENT_GAMES_BEGIN',
    GET_RECENT_GAMES_SUCCESS: 'GET_RECENT_GAMES_SUCCESS',
    GET_RECENT_GAMES_ERROR: 'GET_RECENT_GAMES_ERROR',

    GET_RANDOM_GAMES_BEGIN: 'GET_RANDOM_GAMES_BEGIN',
    GET_RANDOM_GAMES_SUCCESS: 'GET_RANDOM_GAMES_SUCCESS',
    GET_RANDOM_GAMES_ERROR: 'GET_RANDOM_GAMES_ERROR',

    GET_TOP_WINNERS_BEGIN: 'GET_TOP_WINNERS_BEGIN',
    GET_TOP_WINNERS_SUCCESS: 'GET_TOP_WINNERS_SUCCESS',
    GET_TOP_WINNERS_ERROR: 'GET_TOP_WINNERS_ERROR',

    GET_TOP_WINNERS_WIDGET_BEGIN: 'GET_TOP_WINNERS_WIDGET_BEGIN',
    GET_TOP_WINNERS_WIDGET_ERROR: 'GET_TOP_WINNERS_WIDGET_ERROR',
    GET_TOP_WINNERS_WIDGET_SUCCESS: 'GET_TOP_WINNERS_WIDGET_SUCCESS',
    GET_TOP_JACKPOTS_BEGIN: 'GET_TOP_JACKPOTS_BEGIN',
    GET_TOP_JACKPOTS_SUCCESS: 'GET_TOP_JACKPOTS_SUCCESS',
    GET_TOP_JACKPOTS_ERROR: 'GET_TOP_JACKPOTS_ERROR',
    SET_RELUM_JACKPOT_SCRIPT_STATE_SUCCESS: "SET_RELUM_JACKPOT_SCRIPT_STATE_SUCCESS",

    GET_RELUM_JACKPOT_TOKEN_BEGIN:'GET_RELUM_JACKPOT_TOKEN_BEGIN',
    GET_RELUM_JACKPOT_TOKEN_SUCCESS:'GET_RELUM_JACKPOT_TOKEN_SUCCESS',
    GET_RELUM_JACKPOT_TOKEN_ERROR:'GET_RELUM_JACKPOT_TOKEN_ERROR',

    /* GAME LAUNCH */
    GET_GAME_LAUNCH_BEGIN: 'GET_GAME_LAUNCH_BEGIN',
    GET_GAME_LAUNCH_SUCCESS: 'GET_GAME_LAUNCH_SUCCESS',
    GET_GAME_LAUNCH_ERROR: 'GET_GAME_LAUNCH_ERROR',
    SET_SELECTED_GAME_CATEGORY: 'SET_SELECTED_GAME_CATEGORY',
    CLEAR_GAMES: 'CLEAR_GAMES',

    /* BONUSES */
    GET_BONUSES_BEGIN: 'GET_BONUSES_BEGIN',
    GET_BONUSES_SUCCESS: 'GET_BONUSES_SUCCESS',
    GET_BONUSES_ERROR: 'GET_BONUSES_ERROR',
    CLOSE_PROMO_CODE_SUCCESS_MODAL: 'CLOSE_PROMO_CODE_SUCCESS_MODAL',

    GET_IMAGE_SET_BEGIN: 'GET_IMAGE_SET_BEGIN',
    GET_IMAGE_SET_ERROR: 'GET_IMAGE_SET_ERROR',
    GET_IMAGE_SET_SUCCESS: 'GET_IMAGE_SET_SUCCESS',

    /* PRIZES */
    GET_PRIZES_BEGIN: 'GET_PRIZES_BEGIN',
    GET_PRIZES_SUCCESS: 'GET_PRIZES_SUCCESS',
    GET_PRIZES_ERROR: 'GET_PRIZES_ERROR',


    //Bonus games
    GET_BONUS_GAMES_BEGIN: 'GET_BONUS_GAMES_BEGIN',
    GET_BONUS_GAMES_SUCCESS: 'GET_BONUS_GAMES_SUCCESS',
    GET_BONUS_GAMES_ERROR: 'GET_BONUS_GAMES_ERROR',

    //Bonus games
    ACTIVATE_PROMO_CODE_BEGIN: 'ACTIVATE_PROMO_CODE_BEGIN',
    ACTIVATE_PROMO_CODE_SUCCESS: 'ACTIVATE_PROMO_CODE_SUCCESS',
    ACTIVATE_PROMO_CODE_ERROR: 'ACTIVATE_PROMO_CODE_ERROR',

    // Bonus campaigns
    GET_BONUS_CAMPAIGNS_BEGIN: 'GET_BONUS_CAMPAIGNS_BEGIN',
    GET_BONUS_CAMPAIGNS_LOAD_MORE_BEGIN: 'GET_BONUS_CAMPAIGNS_LOAD_MORE_BEGIN',
    GET_BONUS_CAMPAIGNS_ERROR: 'GET_BONUS_CAMPAIGNS_ERROR',
    GET_BONUS_CAMPAIGNS_SUCCESS: 'GET_BONUS_CAMPAIGNS_SUCCESS',

    // Bonus details
    GET_BONUS_DETAILS_BEGIN: 'GET_BONUS_DETAILS_BEGIN',
    GET_BONUS_DETAILS_ERROR: 'GET_BONUS_DETAILS_ERROR',
    GET_BONUS_DETAILS_SUCCESS: 'GET_BONUS_DETAILS_SUCCESS',

    // Bonus products
    GET_BONUS_PRODUCTS_BEGIN: 'GET_BONUS_PRODUCTS_BEGIN',
    GET_BONUS_PRODUCTS_LOAD_MORE_BEGIN: 'GET_BONUS_PRODUCTS_LOAD_MORE_BEGIN',
    GET_BONUS_PRODUCTS_ERROR: 'GET_BONUS_PRODUCTS_ERROR',
    GET_BONUS_PRODUCTS_SUCCESS: 'GET_BONUS_PRODUCTS_SUCCESS',

    ACTIVATE_BONUS_CAMPAIGN_BEGIN: 'ACTIVATE_BONUS_CAMPAIGN_BEGIN',
    ACTIVATE_BONUS_CAMPAIGN_ERROR: 'ACTIVATE_BONUS_CAMPAIGN_ERROR',
    ACTIVATE_BONUS_CAMPAIGN_SUCCESS: 'ACTIVATE_BONUS_CAMPAIGN_SUCCESS',
    CANCEL_BONUS_CAMPAIGN_BEGIN: 'CANCEL_BONUS_CAMPAIGN_BEGIN',
    CANCEL_BONUS_CAMPAIGN_ERROR: 'CANCEL_BONUS_CAMPAIGN_ERROR',
    CANCEL_BONUS_CAMPAIGN_SUCCESS: 'CANCEL_BONUS_CAMPAIGN_SUCCESS',
    RESUME_BONUS_CAMPAIGN_BEGIN: 'RESUME_BONUS_CAMPAIGN_BEGIN',
    RESUME_BONUS_CAMPAIGN_SUCCESS: 'RESUME_BONUS_CAMPAIGN_SUCCESS',
    RESUME_BONUS_CAMPAIGN_ERROR: 'RESUME_BONUS_CAMPAIGN_ERROR',

    GET_SPORT_TYPES_BEGIN: 'GET_SPORT_TYPES_BEGIN',
    GET_SPORT_TYPES_ERROR: 'GET_SPORT_TYPES_ERROR',
    GET_SPORT_TYPES_SUCCESS: 'GET_SPORT_TYPES_SUCCESS',

    GET_BONUS_TOURNAMENTS_BEGIN: 'GET_BONUS_TOURNAMENTS_BEGIN',
    GET_BONUS_TOURNAMENTS_ERROR: 'GET_BONUS_TOURNAMENTS_ERROR',
    GET_BONUS_TOURNAMENTS_SUCCESS: 'GET_BONUS_TOURNAMENTS_SUCCESS',

    GET_BONUS_EVENTS_BEGIN: 'GET_BONUS_EVENTS_BEGIN',
    GET_BONUS_EVENTS_ERROR: 'GET_BONUS_EVENTS_ERROR',
    GET_BONUS_EVENTS_SUCCESS: 'GET_BONUS_EVENTS_SUCCESS',
    //Bonus switcher
    GET_BONUS_WALLET_BEGIN: 'GET_BONUS_WALLET_BEGIN',
    GET_BONUS_WALLET_SUCCESS: 'GET_BONUS_WALLET_SUCCESS',
    GET_BONUS_WALLET_ERROR: 'GET_BONUS_WALLET_ERROR',
    CHANGE_CLIENT_BONUS_WALLET_STATE: 'CHANGE_CLIENT_BONUS_WALLET_STATE',
    CHECK_BALANCE_SWITCHER: 'CHECK_BALANCE_SWITCHER',

    // myauuu

    GET_CLIENT_ACTIVE_BONUS_SETTINGS_COUNT_BEGIN: 'GET_CLIENT_ACTIVE_BONUS_SETTINGS_COUNT_BEGIN',
    GET_CLIENT_ACTIVE_BONUS_SETTINGS_COUNT_ERROR: 'GET_CLIENT_ACTIVE_BONUS_SETTINGS_COUNT_ERROR',
    GET_CLIENT_ACTIVE_BONUS_SETTINGS_COUNT_SUCCESS: 'GET_CLIENT_ACTIVE_BONUS_SETTINGS_COUNT_SUCCESS',
    SET_CLIENT_NEW_BONUS_SETTINGS_COUNT_SUCCESS: 'SET_CLIENT_NEW_BONUS_SETTINGS_COUNT_SUCCESS',

    /* CASHIER */

    GET_PAYMENT_GROUPS_BEGIN: 'GET_PAYMENT_GROUPS_BEGIN',
    GET_PAYMENT_GROUPS_SUCCESS: 'GET_PAYMENT_GROUPS_SUCCESS',
    GET_PAYMENT_GROUPS_ERROR: 'GET_PAYMENT_GROUPS_ERROR',

    CASHIER_WITHDRAWAL_BEGIN: 'CASHIER_WITHDRAWAL_BEGIN',
    CASHIER_WITHDRAWAL_SUCCESS: 'CASHIER_WITHDRAWAL_SUCCESS',
    CASHIER_WITHDRAWAL_ERROR: 'CASHIER_WITHDRAWAL_ERROR',

    CASHIER_DEPOSIT_BEGIN: 'CASHIER_DEPOSIT_BEGIN',
    CASHIER_DEPOSIT_SUCCESS: 'CASHIER_DEPOSIT_SUCCESS',
    CASHIER_DEPOSIT_ERROR: 'CASHIER_DEPOSIT_ERROR',
    CASHIER_IFRAME_DEPOSIT_SUCCESS: 'CASHIER_IFRAME_DEPOSIT_SUCCESS',

    CASHIER_DEPOSIT_RECEIPT: 'CASHIER_DEPOSIT_RECEIPT',

    /* PAYMENTS */
    CLEAR_PAYMENT_MESSAGES: 'CLEAR_PAYMENT_MESSAGES',

    GET_PAYMENTS_BEGIN: 'GET_PAYMENTS_BEGIN',
    GET_PAYMENTS_SUCCESS: 'GET_PAYMENTS_SUCCESS',
    GET_PAYMENTS_ERROR: 'GET_PAYMENTS_ERROR',

    DO_WITHDRAWAL_BEGIN: 'DO_WITHDRAWAL_BEGIN',
    DO_WITHDRAWAL_SUCCESS: 'DO_WITHDRAWAL_SUCCESS',
    DO_WITHDRAWAL_ERROR: 'DO_WITHDRAWAL_ERROR',

    DO_DEPOSIT_BEGIN: 'DO_DEPOSIT_BEGIN',
    DO_DEPOSIT_SUCCESS: 'DO_DEPOSIT_SUCCESS',
    DO_DEPOSIT_ERROR: 'DO_DEPOSIT_ERROR',
    PAYMENT_IFRAME_SUCCESS: 'PAYMENT_IFRAME_SUCCESS',
    /* SECURITY */
    GET_SECURITY_CODE_BEGIN: 'GET_SECURITY_CODE_BEGIN',
    GET_SECURITY_CODE_ERROR: 'GET_SECURITY_CODE_ERROR',
    GET_SECURITY_CODE_SUCCESS: 'GET_SECURITY_CODE_SUCCESS',

    SWITCH_AUTH_BEGIN: 'SWITCH_AUTH_BEGIN',
    SWITCH_AUTH_ERROR: 'SWITCH_AUTH_ERROR',
    SWITCH_AUTH_SUCCESS: 'SWITCH_AUTH_SUCCESS',

    /* ACCOUNT VERIFICATION */

    NOT_VERIFIED_ACCOUNT: 'NOT_VERIFIED_ACCOUNT',

    //Email verification
    VERIFY_ACCOUNT_EMAIL_BEGIN: 'VERIFY_ACCOUNT_EMAIL_BEGIN',
    VERIFY_ACCOUNT_EMAIL_SUCCESS: 'VERIFY_ACCOUNT_EMAIL_SUCCESS',
    VERIFY_ACCOUNT_EMAIL_FAILURE: 'VERIFY_ACCOUNT_EMAIL_FAILURE',
    UNVERIFY_ACCOUNT_EMAIL: 'UNVERIFY_ACCOUNT_EMAIL',

    //Re-send verification code
    RESEND_EMAIL_VERIFICATION_CODE_BEGIN: 'RESEND_EMAIL_VERIFICATION_CODE_BEGIN',
    RESEND_EMAIL_VERIFICATION_CODE_SUCCESS: 'RESEND_EMAIL_VERIFICATION_CODE_SUCCESS',
    RESEND_EMAIL_VERIFICATION_CODE_FAILURE: 'RESEND_EMAIL_VERIFICATION_CODE_FAILURE',
    RESEND_EMAIL_VERIFICATION_MESSAGE: 'RESEND_EMAIL_VERIFICATION_MESSAGE',
    RESEND_EMAIL_VERIFICATION_MESSAGE_CANCEL: 'RESEND_EMAIL_VERIFICATION_MESSAGE_CANCEL',
    REFRESH_TOKEN_BEGIN: 'REFRESH_TOKEN_BEGIN',
    REFRESH_TOKEN_SUCCESS: 'REFRESH_TOKEN_SUCCESS',
    SET_REDIRECT_URL: 'SET_REDIRECT_URL',

    //Mobile verification
    VERIFY_ACCOUNT_MOBILE_BEGIN: 'VERIFY_ACCOUNT_MOBILE_BEGIN',
    VERIFY_ACCOUNT_MOBILE_SUCCESS: 'VERIFY_ACCOUNT_MOBILE_SUCCESS',
    VERIFY_ACCOUNT_MOBILE_FAILURE: 'VERIFY_ACCOUNT_MOBILE_FAILURE',
    UNVERIFY_ACCOUNT_MOBILE: 'UNVERIFY_ACCOUNT_MOBILE',
    RESEND_MOBILE_VERIFICATION_MESSAGE: 'RESEND_MOBILE_VERIFICATION_MESSAGE',
    RESEND_MOBILE_VERIFICATION_MESSAGE_CANCEL: 'RESEND_MOBILE_VERIFICATION_MESSAGE_CANCEL',

    UNVERIFY_DOCUMENT_NUMBER: 'UNVERIFY_DOCUMENT_NUMBER',
    // Upload File
    UPLOAD_FILE_BEGIN: 'UPLOAD_FILE_BEGIN',
    UPLOAD_FILE_ERROR: 'UPLOAD_FILE_ERROR',
    UPLOAD_FILE_SUCCESS: 'UPLOAD_FILE_SUCCESS',

    // KYC
    GET_KYC_BEGIN: 'GET_KYC_BEGIN',
    GET_KYC_ERROR: 'GET_KYC_ERROR',
    GET_KYC_SUCCESS: 'GET_KYC_SUCCESS',
    SET_KYC_BEGIN: 'SET_KYC_BEGIN',
    SET_KYC_ERROR: 'SET_KYC_ERROR',
    SET_KYC_SUCCESS: 'SET_KYC_SUCCESS',
    OPEN_ONE_CLICK_POPUP: 'OPEN_ONE_CLICK_POPUP',

    GET_PLAYER_DOCUMENTS_STATES_BEGIN: 'GET_PLAYER_DOCUMENTS_STATES_BEGIN',
    GET_PLAYER_DOCUMENTS_STATES_ERROR: 'GET_PLAYER_DOCUMENTS_STATES_ERROR',
    GET_PLAYER_DOCUMENTS_STATES_SUCCESS: 'GET_PLAYER_DOCUMENTS_STATES_SUCCESS',

    //Re-send verification code
    RESEND_MOBILE_VERIFICATION_CODE_BEGIN: 'RESEND_MOBILE_VERIFICATION_CODE_BEGIN',
    RESEND_MOBILE_VERIFICATION_CODE_SUCCESS: 'RESEND_MOBILE_VERIFICATION_CODE_SUCCESS',
    RESEND_MOBILE_VERIFICATION_CODE_FAILURE: 'RESEND_MOBILE_VERIFICATION_CODE_FAILURE',

    // Get Player Data
    GET_PLAYER_DATA_BEGIN: 'GET_PLAYER_DATA_BEGIN',
    PLAYER_DATA_RESET: 'PLAYER_DATA_RESET',
    GET_PLAYER_DATA_ERROR: 'GET_PLAYER_DATA_ERROR',
    GET_PLAYER_DATA_SUCCESS: 'GET_PLAYER_DATA_SUCCESS',
    GET_PLAYER_BALANCE_BEGIN: 'GET_PLAYER_BALANCE_BEGIN',
    GET_PLAYER_BALANCE_ERROR: 'GET_PLAYER_BALANCE_ERROR',
    GET_PLAYER_BALANCE_SUCCESS: 'GET_PLAYER_BALANCE_SUCCESS',
    SET_PLAYER_SPORT_BONUS_BALANCE: 'SET_PLAYER_SPORT_BONUS_BALANCE',
    SET_PLAYER_SPORT_TOURNAMENTS_BALANCE: 'SET_PLAYER_SPORT_TOURNAMENTS_BALANCE',
    GET_ACCOUNT_WALLETS_ERROR: 'GET_ACCOUNT_WALLETS_ERROR',
    GET_ACCOUNT_WALLETS_SUCCESS: 'GET_ACCOUNT_WALLETS_SUCCESS',
    GET_REACH_LIMIT: 'GET_REACH_LIMIT',
    SET_PROMPT_LIMITS: 'SET_PROMPT_LIMITS',
    GET_UNVERIFIED_USER_REMINDER: 'GET_UNVERIFIED_USER_REMINDER',


    //Settings
    GET_SETTINGS_BEGIN: 'GET_SETTINGS_BEGIN',
    RESET_STORE: 'RESET',
    GET_SETTINGS_AND_RESET_LOGO_BEGIN: 'GET_SETTINGS_AND_RESET_LOGO_BEGIN',
    GET_SETTINGS_SUCCESS: 'GET_SETTINGS_SUCCESS',
    GET_SETTINGS_ERROR: 'GET_SETTINGS_ERROR',
    GET_COUNTRIES_BEGIN: 'GET_COUNTRIES_BEGIN',
    GET_COUNTRIES_ERROR: 'GET_COUNTRIES_ERROR',
    GET_COUNTRIES_SUCCESS: 'GET_COUNTRIES_SUCCESS',
    GET_CITIES_BEGIN: 'GET_CITIES_BEGIN',
    GET_CITIES_ERROR: 'GET_CITIES_ERROR',
    GET_CITIES_SUCCESS: 'GET_CITIES_SUCCESS',
    GET_REGIONS_BEGIN: 'GET_REGIONS_BEGIN',
    GET_REGIONS_ERROR: 'GET_REGIONS_ERROR',
    GET_REGIONS_SUCCESS: 'GET_REGIONS_SUCCESS',
    UPDATE_LOGO: 'UPDATE_LOGO',
    GET_REGISTRATION_SETTINGS_BEGIN: 'GET_REGISTRATION_SETTINGS_BEGIN',
    GET_REGISTRATION_SETTINGS_ERROR: 'GET_REGISTRATION_SETTINGS_ERROR',
    GET_REGISTRATION_SETTINGS_SUCCESS: 'GET_REGISTRATION_SETTINGS_SUCCESS',
    GET_LOGIN_SETTINGS_BEGIN: 'GET_LOGIN_SETTINGS_BEGIN',
    GET_LOGIN_SETTINGS_ERROR: 'GET_LOGIN_SETTINGS_ERROR',
    GET_LOGIN_SETTINGS_SUCCESS: 'GET_LOGIN_SETTINGS_SUCCESS',
    GET_PROFILE_SETTINGS_BEGIN: 'GET_PROFILE_SETTINGS_BEGIN',
    GET_PROFILE_SETTINGS_ERROR: 'GET_PROFILE_SETTINGS_ERROR',
    GET_PROFILE_SETTINGS_SUCCESS: 'GET_PROFILE_SETTINGS_SUCCESS',
    GET_NSEP_BEGIN: 'GET_NSEP_BEGIN',
    GET_NSEP_ERROR: 'GET_NSEP_ERROR',
    GET_NSEP_SUCCESS: 'GET_NSEP_SUCCESS',
    GET_KYC_AID_BEGIN: 'GET_KYC_AID_BEGIN',
    GET_KYC_AID_ERROR: 'GET_KYC_AID_ERROR',
    GET_KYC_AID_SUCCESS: 'GET_KYC_AID_SUCCESS',
    GET_SPORT_BEGIN: 'GET_SPORT_BEGIN',
    GET_SPORT_ERROR: 'GET_SPORT_ERROR',
    GET_SPORT_SUCCESS: 'GET_SPORT_SUCCESS',
    SET_COLOR_MODE: 'SET_COLOR_MODE',
    SET_POPUPS_COLOR_MODE: 'SET_POPUPS_COLOR_MODE',
    SET_CURRENCY_ID: 'SET_CURRENCY_ID',

    //SEO Settings
    GET_SEO_SETTINGS_BEGIN: 'GET_SEO_SETTINGS_BEGIN',
    GET_SEO_SETTINGS_SUCCESS: 'GET_SEO_SETTINGS_SUCCESS',
    GET_SEO_SETTINGS_ERROR: 'GET_SEO_SETTINGS_ERROR',
    SET_SEO_SETTINGS_PARAMS: 'SET_SEO_SETTINGS_PARAMS',

    GET_SEO_SCHEMA_BEGIN: 'GET_SEO_SCHEMA_BEGIN',
    GET_SEO_SCHEMA_SUCCESS: 'GET_SEO_SCHEMA_SUCCESS',
    GET_SEO_SCHEMA_ERROR: 'GET_SEO_SCHEMA_ERROR',
    GET_SEO_CONTENT_SUCCESS: 'GET_SEO_CONTENT_SUCCESS',
    SET_SEO_PATHS_PARAMS: 'SET_SEO_PATHS_PARAMS',
    SET_SEO_CONTENT_PARAMS: 'SET_SEO_CONTENT_PARAMS',

    //UI Customization
    RESET_POPUPS_VISIBILITY: 'RESET_POPUPS_VISIBILITY',
    RESET_AGENT_LOGIN: 'RESET_AGENT_LOGIN',
    GET_CONTROLS_BEGIN: 'GET_CONTROLS_BEGIN',
    GET_CONTROLS_ERROR: 'GET_CONTROLS_ERROR',
    GET_CONTROLS_SUCCESS: 'GET_CONTROLS_SUCCESS',
    CHANGE_POPUP_VISIBILITY: 'CHANGE_POPUP_VISIBILITY',
    CHANGE_POPUP_VISIBILITY_NO_RESET: 'CHANGE_POPUP_VISIBILITY_NO_RESET',
    RESET_POPUP_CALLBACK: 'RESET_POPUP_CALLBACK',
    CHANGE_MY_PROFILE_POPUP_VISIBILITY: 'CHANGE_MY_PROFILE_POPUP_VISIBILITY',
    OPEN_SPORT_BET_HISTORY: 'OPEN_SPORT_BET_HISTORY',
    SET_DEMO_MODE: 'SET_DEMO_MODE',
    CHANGE_MULTIVIEW_GRID: 'CHANGE_MULTIVIEW_GRID',

    // Messages
    GET_CLIENT_MESSAGES_BEGIN: 'GET_CLIENT_MESSAGES_BEGIN',
    GET_CLIENT_MESSAGES_AND_KEEP_OLD_BEGIN: 'GET_CLIENT_MESSAGES_AND_KEEP_OLD_BEGIN',
    GET_CLIENT_MESSAGES_ERROR: 'GET_CLIENT_MESSAGES_ERROR',
    GET_CLIENT_MESSAGES_SUCCESS: 'GET_CLIENT_MESSAGES_SUCCESS',
    GET_CLIENT_MESSAGES_AND_KEEP_OLD_SUCCESS: 'GET_CLIENT_MESSAGES_AND_KEEP_OLD_SUCCESS',
    MARK_IDS_READ: 'MARK_IDS_READ',
    READ_MESSAGE: 'READ_MESSAGE',
    GET_CLIENT_UNREAD_MESSAGES_COUNT_BEGIN: 'GET_CLIENT_UNREAD_MESSAGES_COUNT_BEGIN',
    GET_CLIENT_UNREAD_MESSAGES_COUNT_ERROR: 'GET_CLIENT_UNREAD_MESSAGES_COUNT_ERROR',
    GET_CLIENT_UNREAD_MESSAGES_COUNT_SUCCESS: 'GET_CLIENT_UNREAD_MESSAGES_COUNT_SUCCESS',
    READ_CLIENT_MESSAGE_BEGIN: 'READ_CLIENT_MESSAGE_BEGIN',
    READ_CLIENT_MESSAGE_ERROR: 'READ_CLIENT_MESSAGE_ERROR',
    READ_CLIENT_MESSAGE_SUCCESS: 'READ_CLIENT_MESSAGE_SUCCESS',
    CHANGE_FITER_POPUP_VISIBILITY: 'CHANGE_FITER_POPUP_VISIBILITY',
    SAVE_MESSAGE_BEGIN: 'SAVE_MESSAGE_BEGIN',
    DELETE_MESSAGE_BEGIN: 'DELETE_MESSAGE_BEGIN',
    DELETE_MESSAGE_SUCCESS: 'DELETE_MESSAGE_SUCCESS',
    DELETE_MESSAGE_ERROR: 'DELETE_MESSAGE_ERROR',
    SAVE_MESSAGE_ERROR: 'SAVE_MESSAGE_ERROR',
    SAVE_MESSAGE_SUCCESS: 'SAVE_MESSAGE_SUCCESS',

    // Translations
    GET_TRANSLATIONS_BEGIN: 'GET_TRANSLATIONS_BEGIN',
    GET_TRANSLATIONS_ERROR: 'GET_TRANSLATIONS_ERROR',
    GET_TRANSLATIONS_SUCCESS: 'GET_TRANSLATIONS_SUCCESS',

    // Banners
    GET_BANNERS_BEGIN: 'GET_BANNERS_BEGIN',
    GET_BANNERS_ERROR: 'GET_BANNERS_ERROR',
    GET_BANNERS_SUCCESS: 'GET_BANNERS_SUCCESS',

    // Notifications
    DISPATCH_NOTIFICATION: 'DISPATCH_NOTIFICATION',
    DISPATCH_ALERT: 'DISPATCH_ALERT',

    // Promotions
    GET_PROMOTIONS_CATEGORIES_BEGIN: 'GET_PROMOTIONS_CATEGORIES_BEGIN',
    GET_PROMOTIONS_CATEGORIES_ERROR: 'GET_PROMOTIONS_CATEGORIES_ERROR',
    GET_PROMOTIONS_CATEGORIES_SUCCESS: 'GET_PROMOTIONS_CATEGORIES_SUCCESS',
    GET_PROMOTIONS_BEGIN: 'GET_PROMOTIONS_BEGIN',
    GET_PROMOTIONS_ERROR: 'GET_PROMOTIONS_ERROR',
    GET_LOAD_MORE_BEGIN: 'GET_LOAD_MORE_BEGIN',
    GET_LOAD_MORE_SUCCESS: 'GET_LOAD_MORE_SUCCESS',
    GET_PROMOTIONS_SUCCESS: 'GET_PROMOTIONS_SUCCESS',
    GET_PROMOTION_BEGIN: 'GET_PROMOTION_BEGIN',
    GET_PROMOTION_ERROR: 'GET_PROMOTION_ERROR',
    GET_PROMOTION_SUCCESS: 'GET_PROMOTION_SUCCESS',
    SET_PROMOTIONS_KEY: 'SET_PROMOTIONS_KEY',
    GET_RANDOM_PROMOTIONS_BEGIN: 'GET_RANDOM_PROMOTIONS_BEGIN',
    GET_RANDOM_PROMOTIONS_SUCCESS: 'GET_RANDOM_PROMOTIONS_SUCCESS',
    GET_RANDOM_PROMOTIONS_ERROR: 'GET_RANDOM_PROMOTIONS_ERROR',
    COLLECT_PROMO_SPINS_BEGIN: 'COLLECT_PROMO_SPINS_BEGIN',
    COLLECT_PROMO_SPINS_SUCCESS: 'COLLECT_PROMO_SPINS_SUCCESS',
    COLLECT_PROMO_SPINS_ERROR: 'COLLECT_PROMO_SPINS_ERROR',
    GET_HIGHLIGHT_PROMOTIONS_BEGIN: 'GET_HIGHLIGHT_PROMOTIONS_BEGIN',
    GET_HIGHLIGHT_PROMOTIONS_SUCCESS: 'GET_HIGHLIGHT_PROMOTIONS_SUCCESS',
    GET_HIGHLIGHT_PROMOTIONS_ERROR: 'GET_HIGHLIGHT_PROMOTIONS_ERROR',

    // Calendar

    GET_CALENDAR_BEGIN: 'GET_CALENDAR_BEGIN',
    GET_CALENDAR_ERROR: 'GET_CALENDAR_ERROR',
    GET_CALENDAR_SUCCESS: 'GET_CALENDAR_SUCCESS',

    // Pages
    GET_PAGE_BEGIN: 'GET_PAGE_BEGIN',
    GET_PAGE_SUCCESS: 'GET_PAGE_SUCCESS',
    GET_PAGE_ERROR: 'GET_PAGE_ERROR',
    RESET_PAGE: 'RESET_PAGE',

    GET_BACKGROUNDS_BEGIN: 'GET_BACKGROUNDS_BEGIN',
    GET_BACKGROUNDS_SUCCESS: 'GET_BACKGROUNDS_SUCCESS',
    GET_BACKGROUNDS_ERROR: 'GET_BACKGROUNDS_ERROR',


    // Transactions
    GET_TRANSACTION_INFO_BEGIN: 'GET_TRANSACTION_INFO_BEGIN',
    GET_TRANSACTION_INFO_ERROR: 'GET_TRANSACTION_INFO_ERROR',
    GET_TRANSACTION_INFO_SUCCESS: 'GET_TRANSACTION_INFO_SUCCESS',
    GET_PAYMENT_REQUESTS_COMMISSIONS_BEGIN: 'GET_PAYMENT_REQUESTS_COMMISSIONS_BEGIN',
    GET_PAYMENT_REQUESTS_COMMISSIONS_ERROR: 'GET_PAYMENT_REQUESTS_COMMISSIONS_ERROR',
    GET_PAYMENT_REQUESTS_COMMISSIONS_SUCCESS: 'GET_PAYMENT_REQUESTS_COMMISSIONS_SUCCESS',
    CONFIRM_REGISTRATION_VERIFICATION_CODE_BEGIN: 'CONFIRM_REGISTRATION_VERIFICATION_CODE_BEGIN',
    CONFIRM_REGISTRATION_VERIFICATION_CODE_ERROR: 'CONFIRM_REGISTRATION_VERIFICATION_CODE_ERROR',
    CHECK_RUSSIAN_VERIFICATION_STATUS_BEGIN: 'CHECK_RUSSIAN_VERIFICATION_STATUS_BEGIN',
    CHECK_RUSSIAN_VERIFICATION_STATUS_ERROR: 'CHECK_RUSSIAN_VERIFICATION_STATUS_ERROR',
    CHECK_RUSSIAN_VERIFICATION_STATUS_SUCCESS: 'CHECK_RUSSIAN_VERIFICATION_STATUS_SUCCESS',
    CHECK_RUSSIAN_VERIFICATIONV2_STATUS_SUCCESS: 'CHECK_RUSSIAN_VERIFICATIONV2_STATUS_SUCCESS',
    CHECK_RUSSIAN_VERIFICATION_STATUSV2_BEGIN: 'CHECK_RUSSIAN_VERIFICATION_STATUSV2_BEGIN',
    CHECK_RUSSIAN_VERIFICATION_STATUSV2_ERROR: 'CHECK_RUSSIAN_VERIFICATION_STATUSV2_ERROR',
    CHECK_RUSSIAN_VERIFICATION_STATUSV2_SUCCESS: 'CHECK_RUSSIAN_VERIFICATION_STATUSV2_SUCCESS',
    GET_CURRENCY_SPECEFIC_SETTINGS_SUCCESS: 'GET_CURRENCY_SPECEFIC_SETTINGS_SUCCESS',
    GET_NEW_PLATCURRENCY_SPECEFIC_SETTINGS_SUCCESS: 'GET_NEW_PLATCURRENCY_SPECEFIC_SETTINGS_SUCCESS',
    GET_SIMPLE_CUPIS_ESIA_SUCCESS: 'GET_SIMPLE_CUPIS_ESIA_SUCCESS',
    GET_SIMPLE_CUPIS_ESIA_BEGIN: 'GET_SIMPLE_CUPIS_ESIA_BEGIN',
    GET_SIMPLE_CUPIS_ESIA_ERROR: 'GET_SIMPLE_CUPIS_ESIA_ERROR',
    GET_TINKOFF_ERROR: 'GET_TINKOFF_ERROR',

    GET_CUPIS_TINKOFF_BEGIN: 'GET_CUPIS_TINKOFF_BEGIN',
    GET_CUPIS_TINKOFF_SUCCESS: 'GET_CUPIS_TINKOFF_SUCCESS',
    // Notifications
    GET_NOTIFICATION_PREFERENCES_BEGIN: 'GET_NOTIFICATION_PREFERENCES_BEGIN',
    GET_NOTIFICATION_PREFERENCES_ERROR: 'GET_NOTIFICATION_PREFERENCES_ERROR',
    GET_NOTIFICATION_PREFERENCES_SUCCESS: 'GET_NOTIFICATION_PREFERENCES_SUCCESS',
    SET_NOTIFICATION_PREFERENCES_BEGIN: 'SET_NOTIFICATION_PREFERENCES_BEGIN',
    SET_NOTIFICATION_PREFERENCES_ERROR: 'SET_NOTIFICATION_PREFERENCES_ERROR',
    SET_NOTIFICATION_PREFERENCES_SUCCESS: 'SET_NOTIFICATION_PREFERENCES_SUCCESS',
    GET_NOTIFICATION_PREFERENCES_RULES_BEGIN: 'GET_NOTIFICATION_PREFERENCES_RULES_BEGIN',
    GET_NOTIFICATION_PREFERENCES_RULES_ERROR: 'GET_NOTIFICATION_PREFERENCES_RULES_ERROR',
    GET_NOTIFICATION_PREFERENCES_RULES_SUCCESS: 'GET_NOTIFICATION_PREFERENCES_RULES_SUCCESS',

    GET_INFO_BLOCK_BEGIN: 'GET_INFO_BLOCK_BEGIN',
    GET_INFO_BLOCK_SUCCESS: 'GET_INFO_BLOCK_SUCCESS',
    GET_INFO_BLOCK_ERROR: 'GET_INFO_BLOCK_ERROR',

    GET_DORMANT_CODE_SUCCESS: 'GET_DORMANT_CODE_SUCCESS',
    GET_DORMANT_CODE_BEGIN: 'GET_DORMANT_CODE_BEGIN',
    GET_DORMANT_CODE_ERROR: 'GET_DORMANT_CODE_ERROR',

    ACCOUNT_CLOSURE_BEGIN: 'ACCOUNT_CLOSURE_BEGIN',
    ACCOUNT_CLOSURE_SUCCESS: 'ACCOUNT_CLOSURE_SUCCESS',
    ACCOUNT_CLOSURE_ERROR: 'ACCOUNT_CLOSURE_ERROR',

    GET_TIME_LIMIT_SUCCESS: 'GET_TIME_LIMIT_SUCCESS',
    GET_TIME_LIMIT_BEGIN: 'GET_TIME_LIMIT_BEGIN',
    GET_TIME_LIMIT_ERROR: 'GET_TIME_LIMIT_ERROR',

    GET_DEPOSIT_LIMIT_SUCCESS: 'GET_DEPOSIT_LIMIT_SUCCESS',
    GET_DEPOSIT_LIMIT_BEGIN: 'GET_DEPOSIT_LIMIT_BEGIN',
    GET_DEPOSIT_LIMIT_ERROR: 'GET_DEPOSIT_LIMIT_ERROR',

    GET_BET_LIMIT_SUCCESS: 'GET_BET_LIMIT_SUCCESS',
    GET_BET_LIMIT_BEGIN: 'GET_BET_LIMIT_BEGIN',
    GET_BET_LIMIT_ERROR: 'GET_BET_LIMIT_ERROR',

    GET_SINGLE_BET_SUCCESS: 'GET_SINGLE_BET_SUCCESS',
    GET_SINGLE_BET_BEGIN: 'GET_SINGLE_BET_BEGIN',
    GET_SINGLE_BET_ERROR: 'GET_SINGLE_BET_ERROR',

    SET_SINGLE_BET_SUCCESS: 'SET_SINGLE_BET_SUCCESS',
    SET_SINGLE_BET_BEGIN: 'SET_SINGLE_BET_BEGIN',
    SET_SINGLE_BET_ERROR: 'SET_SINGLE_BET_ERROR',

    GET_ACCESS_LIMIT_SUCCESS: 'GET_ACCESS_LIMIT_SUCCESS',
    GET_ACCESS_LIMIT_BEGIN: 'GET_ACCESS_LIMIT_BEGIN',
    GET_ACCESS_LIMIT_ERROR: 'GET_ACCESS_LIMIT_ERROR',

    GET_ACCESS_LIMIT_OVERVIEW_SUCCESS: 'GET_ACCESS_LIMIT_OVERVIEW_SUCCESS',
    GET_ACCESS_LIMIT_OVERVIEW_BEGIN: 'GET_ACCESS_LIMIT_OVERVIEW_BEGIN',
    GET_ACCESS_LIMIT_OVERVIEW_ERROR: 'GET_ACCESS_LIMIT_OVERVIEW_ERROR',

    GET_ACCESS_LIMIT_PENDING_SUCCESS: 'GET_ACCESS_LIMIT_PENDING_SUCCESS',
    GET_ACCESS_LIMIT_PENDING_BEGIN: 'GET_ACCESS_LIMIT_PENDING_BEGIN',
    GET_ACCESS_LIMIT_PENDING_ERROR: 'GET_ACCESS_LIMIT_PENDING_ERROR',

    GET_TIME_OUT_SUCCESS: 'GET_TIME_OUT_SUCCESS',
    GET_TIME_OUT_BEGIN: 'GET_TIME_OUT_BEGIN',
    GET_TIME_OUT_ERROR: 'GET_TIME_OUT_ERROR',

    GET_SELF_EXCLUSION_SUCCESS: 'GET_SELF_EXCLUSION_SUCCESS',
    GET_SELF_EXCLUSION_BEGIN: 'GET_SELF_EXCLUSION_BEGIN',
    GET_SELF_EXCLUSION_ERROR: 'GET_SELF_EXCLUSION_ERROR',

    GET_EXCLUSION_REASONS_SUCCESS: 'GET_EXCLUSION_REASONS_SUCCESS',
    GET_EXCLUSION_REASONS_BEGIN: 'GET_EXCLUSION_REASONS_BEGIN',
    GET_EXCLUSION_REASONS_ERROR: 'GET_EXCLUSION_REASONS_ERROR',

    GET_REALITY_CHECK_SUCCESS: 'GET_REALITY_CHECK_SUCCESS',
    GET_REALITY_CHECK_BEGIN: 'GET_REALITY_CHECK_BEGIN',
    GET_REALITY_CHECK_ERROR: 'GET_REALITY_CHECK_ERROR',
    REALITY_CHECK_POPUP_VISIBILITY: 'REALITY_CHECK_POPUP_VISIBILITY',

    GET_LOSS_LIMIT_SUCCESS: 'GET_LOSS_LIMIT_SUCCESS',
    GET_LOSS_LIMIT_BEGIN: 'GET_LOSS_LIMIT_BEGIN',
    GET_LOSS_LIMIT_ERROR: 'GET_LOSS_LIMIT_ERROR',

    SET_LOSS_LIMIT_SUCCESS: 'SET_LOSS_LIMIT_SUCCESS',
    SET_LOSS_LIMIT_BEGIN: 'SET_LOSS_LIMIT_BEGIN',
    SET_LOSS_LIMIT_ERROR: 'SET_LOSS_LIMIT_ERROR',

    SHOW_BALANCE: 'SHOW_BALANCE',

    GET_LOBBY_CATEGORIES_BEGIN: 'GET_LOBBY_CATEGORIES_BEGIN',
    GET_LOBBY_CATEGORIES_ERROR: 'GET_LOBBY_CATEGORIES_ERROR',
    GET_LOBBY_CATEGORIES_SUCCESS: 'GET_LOBBY_CATEGORIES_SUCCESS',

    GET_LOBBY_GROUPS_BEGIN: 'GET_LOBBY_GROUPS_BEGIN',
    GET_LOBBY_GROUPS_ERROR: 'GET_LOBBY_GROUPS_ERROR',
    GET_LOBBY_GROUPS_SUCCESS: 'GET_LOBBY_GROUPS_SUCCESS',

    GET_JACKPOTWIDGET_BEGIN: 'GET_JACKPOTWIDGET_BEGIN',
    GET_JACKPOTWIDGET_ERROR: 'GET_JACKPOTWIDGET_ERROR',
    GET_JACKPOTWIDGET_SUCCESS: 'GET_JACKPOTWIDGET_SUCCESS',

    GET_LOBBY_PRODUCTS_BEGIN: 'GET_LOBBY_PRODUCTS_BEGIN',
    GET_LOBBY_PRODUCTS_ERROR: 'GET_LOBBY_PRODUCTS_ERROR',
    GET_LOBBY_PRODUCTS_SUCCESS: 'GET_LOBBY_PRODUCTS_SUCCESS',
    GET_LOBBY_PRODUCT_BEGIN: 'GET_LOBBY_PRODUCT_BEGIN',
    GET_LOBBY_PRODUCT_ERROR: 'GET_LOBBY_PRODUCT_ERROR',
    GET_LOBBY_PRODUCT_SUCCESS: 'GET_LOBBY_PRODUCT_SUCCESS',
    GET_LOBBY_PRODUCTS_AND_KEEP_OLD_BEGIN: 'GET_LOBBY_PRODUCTS_AND_KEEP_OLD_BEGIN',
    GET_LOBBY_PRODUCTS_AND_KEEP_OLD_ERROR: 'GET_LOBBY_PRODUCTS_AND_KEEP_OLD_ERROR',
    GET_LOBBY_PRODUCTS_AND_KEEP_OLD_SUCCESS: 'GET_LOBBY_PRODUCTS_AND_KEEP_OLD_SUCCESS',

    GET_LOBBY_BEGIN: 'GET_LOBBY_BEGIN',
    GET_LOBBY_ERROR: 'GET_LOBBY_ERROR',
    GET_LOBBY_SUCCESS: 'GET_LOBBY_SUCCESS',

    GET_FILTERS_BEGIN: 'GET_FILTERS_BEGIN',
    GET_FILTERS_ERROR: 'GET_FILTERS_ERROR',
    GET_FILTERS_SUCCESS: 'GET_FILTERS_SUCCESS',

    GET_MY_CASINO_GAMES_BEGIN: 'GET_MY_CASINO_GAMES_BEGIN',
    GET_MY_CASINO_GAMES_ERROR: 'GET_MY_CASINO_GAMES_ERROR',
    GET_MY_CASINO_GAMES_SUCCESS: 'GET_MY_CASINO_GAMES_SUCCESS',

    GET_MOST_LIKED_PRODUCTS_BEGIN: 'GET_MOST_LIKED_PRODUCTS_BEGIN',
    GET_MOST_LIKED_PRODUCTS_ERROR: 'GET_MOST_LIKED_PRODUCTS_ERROR',
    GET_MOST_LIKED_PRODUCTS_SUCCESS: 'GET_MOST_LIKED_PRODUCTS_SUCCESS',

    LIKE_PRODUCT_BEGIN: 'LIKE_PRODUCT_BEGIN',
    LIKE_PRODUCT_ERROR: 'LIKE_PRODUCT_ERROR',
    LIKE_PRODUCT_SUCCESS: 'LIKE_PRODUCT_SUCCESS',

    DISLIKE_PRODUCT_BEGIN: 'DISLIKE_PRODUCT_BEGIN',
    DISLIKE_PRODUCT_ERROR: 'DISLIKE_PRODUCT_ERROR',
    DISLIKE_PRODUCT_SUCCESS: 'DISLIKE_PRODUCT_SUCCESS',

    ADD_FAVORITE_PRODUCT_BEGIN: 'ADD_FAVORITE_PRODUCT_BEGIN',
    ADD_FAVORITE_PRODUCT_ERROR: 'ADD_FAVORITE_PRODUCT_ERROR',
    ADD_FAVORITE_PRODUCT_SUCCESS: 'ADD_FAVORITE_PRODUCT_SUCCESS',

    SET_LIKE_FAV_GAMES_STATUS: 'SET_LIKE_FAV_GAMES_STATUS',

    REMOVE_FAVORITE_PRODUCT_BEGIN: 'REMOVE_FAVORITE_PRODUCT_BEGIN',
    REMOVE_FAVORITE_PRODUCT_ERROR: 'REMOVE_FAVORITE_PRODUCT_ERROR',
    REMOVE_FAVORITE_PRODUCT_SUCCESS: 'REMOVE_FAVORITE_PRODUCT_SUCCESS',

    GET_LAST_PLAYED_PRODUCTS_BEGIN: 'GET_LAST_PLAYED_PRODUCTS_BEGIN',
    GET_LAST_PLAYED_PRODUCTS_ERROR: 'GET_LAST_PLAYED_PRODUCTS_ERROR',
    GET_LAST_PLAYED_PRODUCTS_SUCCESS: 'GET_LAST_PLAYED_PRODUCTS_SUCCESS',

    GET_TRENDING_PRODUCTS_BEGIN: 'GET_TRENDING_PRODUCTS_BEGIN',
    GET_TRENDING_PRODUCTS_ERROR: 'GET_TRENDING_PRODUCTS_ERROR',
    GET_TRENDING_PRODUCTS_SUCCESS: 'GET_TRENDING_PRODUCTS_SUCCESS',

    GET_LEFTBAR_PRODUCTS_BEGIN: 'GET_LEFTBAR_PRODUCTS_BEGIN',
    GET_LEFTBAR_PRODUCTS_ERROR: 'GET_LEFTBAR_PRODUCTS_ERROR',
    GET_LEFTBAR_PRODUCTS_SUCCESS: 'GET_LEFTBAR_PRODUCTS_SUCCESS',

    GET_SEO_PAGE_PRODUCTS_BEGIN: 'GET_SEO_PAGE_PRODUCTS_BEGIN',
    GET_SEO_PAGE_PRODUCTS_ERROR: 'GET_SEO_PAGE_PRODUCTS_ERROR',
    GET_SEO_PAGE_PRODUCTS_SUCCESS: 'GET_SEO_PAGE_PRODUCTS_SUCCESS',

    GET_GAME_VIEW_PRODUCTS_BEGIN: 'GET_GAME_VIEW_PRODUCTS_BEGIN',
    GET_GAME_VIEW_PRODUCTS_ERROR: 'GET_GAME_VIEW_PRODUCTS_ERROR',
    GET_GAME_VIEW_PRODUCTS_SUCCESS: 'GET_GAME_VIEW_PRODUCTS_SUCCESS',
    RESET_MULTIVIEW_LOADING_STATE: 'RESET_MULTIVIEW_LOADING_STATE',

    ADD_MULTIVIEW_GAME: 'ADD_MULTIVIEW_GAME',
    SELECT_CASINO_GAME: 'SELECT_CASINO_GAME',
    CHANGE_LOGIN_STATE: 'CHANGE_LOGIN_STATE',

    GET_TOURNAMENTS_BEGIN: 'GET_TOURNAMENTS_BEGIN',
    GET_TOURNAMENTS_AND_KEEP_OLD_BEGIN: 'GET_TOURNAMENTS_AND_KEEP_OLD_BEGIN',
    GET_TOURNAMENTS_ERROR: 'GET_TOURNAMENTS_ERROR',
    GET_TOURNAMENTS_AND_KEEP_OLD_SUCCESS: 'GET_TOURNAMENTS_AND_KEEP_OLD_SUCCESS',
    GET_TOURNAMENTS_SUCCESS: 'GET_TOURNAMENTS_SUCCESS',
    GET_TOURNAMENT_GAMES_BEGIN: 'GET_TOURNAMENT_GAMES_BEGIN',
    GET_TOURNAMENT_GAMES_ERROR: 'GET_TOURNAMENT_GAMES_ERROR',
    GET_TOURNAMENT_GAMES_SUCCESS: 'GET_TOURNAMENT_GAMES_SUCCESS',
    GET_TOURNAMENT_BEGIN: 'GET_TOURNAMENT_BEGIN',
    GET_TOURNAMENT_ERROR: 'GET_TOURNAMENT_ERROR',
    GET_TOURNAMENT_SUCCESS: 'GET_TOURNAMENT_SUCCESS',
    JOIN_TOURNAMENT_BEGIN: 'JOIN_TOURNAMENT_BEGIN',
    JOIN_TOURNAMENT_ERROR: 'JOIN_TOURNAMENT_ERROR',
    JOIN_TOURNAMENT_SUCCESS: 'JOIN_TOURNAMENT_SUCCESS',
    JOIN_TOURNAMENT_IN_LIST_SUCCESS: 'JOIN_TOURNAMENT_IN_LIST_SUCCESS',

    GET_WIDGET_BEGIN: 'GET_WIDGET_BEGIN',
    GET_WIDGET_ERROR: 'GET_WIDGET_ERROR',
    GET_WIDGET_SUCCESS: 'GET_WIDGET_SUCCESS',
    GET_WIDGET_FOR_PREVIEW_SUCCESS: 'GET_WIDGET_FOR_PREVIEW_SUCCESS',
    SET_WIDGET_PREVIEW: 'SET_WIDGET_PREVIEW',
    SET_WIDGET_TRANSLATIONS: 'SET_WIDGET_TRANSLATIONS',
    GET_WIDGET_TRANSLATIONS_SUCCESS: 'GET_WIDGET_TRANSLATIONS_SUCCESS',

    GET_BUSINESS_RULES_BEGIN: 'GET_BUSINESS_RULES_BEGIN',
    GET_BUSINESS_RULES_ERROR: 'GET_BUSINESS_RULES_ERROR',
    GET_BUSINESS_RULES_SUCCESS: 'GET_BUSINESS_RULES_SUCCESS',
    GET_POPUP_BEGIN: 'GET_POPUP_BEGIN',
    GET_POPUP_SUCCESS: 'GET_POPUP_SUCCESS',
    GET_POPUP_ERROR: 'GET_POPUP_ERROR',
    CHANGE_POPUP_SETTINGS: 'CHANGE_POPUP_SETTINGS',
    SHOW_CUSTOM_POPUP: 'SHOW_CUSTOM_POPUP',
    HIDE_CUSTOM_POPUP: 'HIDE_CUSTOM_POPUP',

    GET_ANNOUNCEMENT_BEGIN: 'GET_ANNOUNCEMENT_BEGIN',
    GET_ANNOUNCEMENT_SUCCESS: 'GET_ANNOUNCEMENT_SUCCESS',
    GET_ANNOUNCEMENT_ERROR: 'GET_ANNOUNCEMENT_ERROR',

    GET_FREE_SPINS_BEGIN: 'GET_FREE_SPINS_BEGIN',
    GET_FREE_SPINS_ERROR: 'GET_FREE_SPINS_ERROR',
    GET_FREE_SPINS_SUCCESS: 'GET_FREE_SPINS_SUCCESS',

    GET_FREE_SPINS_GAMES_BEGIN: 'GET_FREE_SPINS_GAMES_BEGIN',
    GET_FREE_SPINS_GAMES_ERROR: 'GET_FREE_SPINS_GAMES_ERROR',
    GET_FREE_SPINS_GAMES_SUCCESS: 'GET_FREE_SPINS_GAMES_SUCCESS',

    GET_STORIES_BEGIN: 'GET_STORIES_BEGIN',
    GET_STORIES_ERROR: 'GET_STORIES_ERROR',
    GET_STORIES_SUCCESS: 'GET_STORIES_SUCCESS',
    RESET_STORIES: 'RESET_STORIES',

    GET_PROMO_BEGIN: 'GET_PROMO_BEGIN',
    GET_PROMO_SUCCESS: 'GET_PROMO_SUCCESS',
    GET_PROMO_ERROR: 'GET_PROMO_ERROR',
    GET_PROMO_PRIZE_BEGIN: 'GET_PROMO_PRIZE_BEGIN',
    GET_PROMO_PRIZE_SUCCESS: 'GET_PROMO_PRIZE_SUCCESS',
    GET_PROMO_PRIZE_ERROR: 'GET_PROMO_PRIZE_ERROR',
    GET_PROMO_WINNINGS_BEGIN: 'GET_PROMO_WINNINGS_BEGIN',
    GET_PROMO_WINNINGS_SUCCESS: 'GET_PROMO_WINNINGS_SUCCESS',
    GET_PROMO_WINNINGS_ERROR: 'GET_PROMO_WINNINGS_ERROR',
    GET_PROMO_BALANCE_BEGIN: 'GET_PROMO_BALANCE_BEGIN',
    GET_PROMO_BALANCE_SUCCESS: 'GET_PROMO_BALANCE_SUCCESS',
    GET_PROMO_BALANCE_ERROR: 'GET_PROMO_BALANCE_ERROR',
    GET_PROMO_SPIN_DATE_BEGIN: 'GET_PROMO_SPIN_DATE_BEGIN',
    GET_PROMO_SPIN_DATE_SUCCESS: 'GET_PROMO_SPIN_DATE_SUCCESS',
    GET_PROMO_SPIN_DATE_ERROR: 'GET_PROMO_SPIN_DATE_ERROR',
    SET_PROMO_TOOL_SETTINGS: 'SET_PROMO_TOOL_SETTINGS',
    GET_PROMO_BALANCE_INFO_SUCCESS: 'GET_PROMO_BALANCE_INFO_SUCCESS',
    GET_PROMO_BALANCE_INFO_BEGIN: 'GET_PROMO_BALANCE_INFO_BEGIN',
    GET_PROMO_BALANCE_INFO_ERROR: 'GET_PROMO_BALANCE_INFO_ERROR',
    GET_EXCHANGE_CENTER_ERROR: 'GET_EXCHANGE_CENTER_ERROR',
    GET_EXCHANGE_CENTER_SUCCESS: 'GET_EXCHANGE_CENTER_SUCCESS',
    GET_EXCHANGE_CENTER_BEGIN: 'GET_EXCHANGE_CENTER_BEGIN',


    //Refer Friend
    GET_CLIENT_INVITES_SUCCESS: 'GET_CLIENT_INVITES_SUCCESS',
    GET_CLIENT_INVITES_BEGIN: 'GET_CLIENT_INVITES_BEGIN',
    GET_CLIENT_INVITES_ERROR: 'GET_CLIENT_INVITES_ERROR',

    GET_CLIENT_GROUPS_SUCCESS: 'GET_CLIENT_GROUPS_SUCCESS',
    GET_CLIENT_GROUPS_BEGIN: 'GET_CLIENT_GROUPS_BEGIN',
    GET_CLIENT_GROUPS_ERROR: 'GET_CLIENT_GROUPS_ERROR',

    GET_REFERRAL_BONUSES_SUCCESS: 'GET_REFERRAL_BONUSES_SUCCESS',
    GET_REFERRAL_BONUSES_BEGIN: 'GET_REFERRAL_BONUSES_BEGIN',
    GET_REFERRAL_BONUSES_ERROR: 'GET_REFERRAL_BONUSES_ERROR',

    GET_REFERRAL_BONUS_DETAILS_SUCCESS: 'GET_REFERRAL_BONUS_DETAILS_SUCCESS',
    GET_REFERRAL_BONUS_DETAILS_BEGIN: 'GET_REFERRAL_BONUS_DETAILS_BEGIN',
    GET_REFERRAL_BONUS_DETAILS_ERROR: 'GET_REFERRAL_BONUS_DETAILS_ERROR',

    INVITE_FRIEND_SUCCESS: 'INVITE_FRIEND_SUCCESS',

    //Campaign page

    GET_BONUS_CAMPAIGNS_PAGE_BEGIN: 'GET_BONUS_CAMPAIGNS_PAGE_BEGIN',
    GET_BONUS_CAMPAIGNS_PAGE_ERROR: 'GET_BONUS_CAMPAIGNS_PAGE_ERROR',
    GET_BONUS_CAMPAIGNS_PAGE_SUCCESS: 'GET_BONUS_CAMPAIGNS_PAGE_SUCCESS',

    JOIN_BONUS_CAMPAIGNS_PAGE_BEGIN: 'JOIN_BONUS_CAMPAIGNS_PAGE_BEGIN',
    JOIN_BONUS_CAMPAIGNS_PAGE_ERROR: 'JOIN_BONUS_CAMPAIGNS_PAGE_ERROR',
    JOIN_BONUS_CAMPAIGNS_PAGE_SUCCESS: 'JOIN_BONUS_CAMPAIGNS_PAGE_SUCCESS',

    //Lobby home

    GET_LOBBY_HOME_NAV_BAR_SUCCESS: 'GET_LOBBY_HOME_NAV_BAR_SUCCESS',
    GET_SEARCH_POPUP_GROUPS_BEGIN: 'GET_SEARCH_POPUP_GROUPS_BEGIN',
    GET_SEARCH_POPUP_GROUPS_ERROR: 'GET_SEARCH_POPUP_GROUPS_ERROR',
    GET_SEARCH_POPUP_GROUPS_SUCCESS: 'GET_SEARCH_POPUP_GROUPS_SUCCESS',

    // BonusSystem
    GET_BONUSES: 'GET_BONUSES',
    SET_BONUSES_LOADING: 'SET_BONUSES_LOADING',
    GET_BONUS_ITEM_DETAILS_SUCCESS: 'GET_BONUS_ITEM_DETAILS_SUCCESS',
    GET_BONUS_PRODUCTS_V2_SUCCESS: 'GET_BONUS_PRODUCTS_V2_SUCCESS',
    GET_BONUS_HISTORY_V2_SUCCESS: 'GET_BONUS_HISTORY_V2_SUCCESS',
    GET_BONUS_HISTORY_V2_DETAILS_SUCCESS: 'GET_BONUS_HISTORY_V2_DETAILS_SUCCESS',
    
    // Offers
    GET_OFFERS_SUCCESS: 'GET_OFFERS_SUCCESS',
    GET_OFFERS_LOADING: 'GET_OFFERS_LOADING',
    GET_OFFERS_LOADING: 'GET_OFFERS_LOADING',
    GET_OFFERS_ITEM_SUCCESS: 'GET_OFFERS_ITEM_SUCCESS',
    GET_OFFER_PRODUCTS_SUCCESS: 'GET_OFFER_PRODUCTS_SUCCESS',
    GET_JOINED_CAMPAIGNS_SUCCESS: 'GET_JOINED_CAMPAIGNS_SUCCESS',

    // self assessment
    GET_SELF_ASSESSMENT_SUCCESS: 'GET_SELF_ASSESSMENT_SUCCESS'
};

export default ActionType;